<template>
    <div class="basicStyle">
       <div class="bg_fff">
        <div class="querySearch">
          <div class="searchItem">
            <span>关键词</span>
            <el-input class="w300" v-model="queryInfo.title" clearable size="small" placeholder=请输入你想搜索的问题关键词></el-input>
          </div>
          <div class="searchItem">
            <MyButton
              value="搜索"
              size="medium"
              icon="el-icon-search"
              type="1"
              @click="queryTable('search')"
            ></MyButton>
            <MyButton
              value="重置"
              size="medium"
              type="2"
              @click="resetQuery"
            ></MyButton>
          </div>
        </div>
  
        <div>
          <div class="table"> 
            <div class="folderListBox">
              <div
                class="folderItem"
                v-for="(item, index) in tableList"
                :key="index"
                @click="details(item)"
               >
                  <p class="cont"><i class="el-icon-video-camera"></i> {{ item.title }}</p>
                  <div class="imgBox">
                    <i class="zzc"></i>
                    <img class="img" :src="item.cover_image" alt="" />
                  </div>
                </div>
            </div> 
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.page"
                :page-sizes="[12, 24, 36, 48]"
                :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="queryInfo.total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

      <el-dialog
        :title="videoInfo.title"
        :visible.sync="videoVisible"
        :before-close="handleClose"
        close-on-click-modal
        > 
          <!-- 视频详情 -->
          <video id="MyVideo" style="width: 100%; height: 600px" poster="image/4.jpg" oncontextmenu="return false" controls controlsList="nodownload" autoplay muted loop>
            <source :src="videoInfo.video_url" type="video/mp4">
          </video>  
      </el-dialog>
    </div>  
    </template> 
    <script>
    import commonApi from "@/api/common"; 
    import TableComponents from "@/components/TableComponents.vue";
    import { clearObj, copyToClip } from "@/utils/index.js";
    import { deepClone } from "@/utils"; 
    import MyButton from "@/components/MyButton.vue";
    export default {
      name: "operateVideo", //操作视频
      components: {
        TableComponents,
        MyButton,
      },
      data() {
        return {
          queryInfo: {
              limit: 12,
              page: 1,
              total: 0, 
          },
          columns: [
              //列数据
              { label: "ID", prop: "id" },
              { label: "标题", prop: "export_name" },
              { label: "分类", prop: "tob_admin_name" },
              { label: "发布时间", prop: "created_at" },
              { label: "状态", prop: "status_name" },
              { label: "操作", prop: "operation" },
          ],
          tableList: [],
  
          statusOptions: [
              //开卡状态：-1全部 0创建中 1开始导出 2导出完成
              {
              value: -1,
              label: "全部",
              },
              {
              value: 0,
              label: "创建中",
              },
              {
              value: 1,
              label: "开始导出",
              },
              {
              value: 2,
              label: "导出完成",
              },
          ],
          videoVisible: false, // 视频弹窗是否显示
          videoInfo:{}
        };
      },
      computed: { 
  
      },
      watch: {
         
      },
      created() {
          this.queryTable();
      },
      methods: { 
        // 关闭
        handleClose(done) {
          done();
        },
        async details(row) {
            const res = await commonApi.getTobVideoInfo({id: row.id});
              if (res.code == 200 && res.data.info) { 
                  this.videoInfo = res.data.info; 
                   
                  this.videoVisible = true;
                  const video = document.getElementById('MyVideo')
                  if(video){
                      video.load() 
                  } 
 
              } else {
                  this.$message.error(res.message);
              }
          }, 
          // 列表数据
          async queryTable(_type) {
              if (_type) {
                  this.queryInfo.page = 1;
              } 
              let params = deepClone(this.queryInfo);
              const res = await commonApi.getVideoList(params);
              if (res.code == 200) {
                  this.queryInfo.total = res.data.total;
                  this.tableList = res.data.list;
                  console.log("getVideoList",res.data.list)
              } else {
                  this.$message.error(res.message);
              }
          },
          // 重置
          resetQuery() {
              this.queryInfo = {
                  limit: 12,
                  page: 1,
                  total: 0, 
              };
              this.queryTable();
          },
          // 分页
          handleSizeChange(e) {
              this.queryInfo.limit = e;
              this.queryTable();
          },
          handleCurrentChange(e) {
              this.queryInfo.page = e;
              this.queryTable();
          },
      },
    };
    </script>
    
    <style lang="less" scoped>
    .basicStyle {
      span {
        display: inline-block;
      }
      .querySearch {
        .searchItem {
          display: inline-block;
          padding: 5px 0;
          margin-right: 30px;
          span {
            margin-right: 10px;
            font-size: 14px;
          }
          /deep/ .el-input {
            width: 250px;
            padding: 5px 0;
          }
        }
        /deep/ .el-button--primary {
          // margin-left: 50px;
        }
      }
      .addInfo {
        margin: 10px 0 20px 0;
      }
    
      // 表格数据
      .table {
        min-height: calc(100vh - 330px);
      } 
    
      // 分页
      .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px;
      }
    
      /deep/ .formDialog {
        .courseDetail {
          img {
            width: 200px;
          }
          .couseUl {
            text-decoration: none;
            height: 400px;
            overflow: auto;
            margin-top: 20px;
            li {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .sellPriceType {
              background-color: rgb(89, 89, 246);
              color: #fff;
              margin: 0 25px;
              width: 100px;
              text-align: center;
              border-radius: 10px;
            }
          }
        }
        .userInfoFormStyle {
          display: flex;
          line-height: 40px;
          margin-bottom: 15px;
          .t1 {
            padding: 0 12px 0 0;
            width: 100px;
            box-sizing: border-box;
            text-align: right;
          }
          .t2 {
          }
          .t3 {
          }
        }
        .userInfoFormStyle-price {
          display: flex;
          line-height: 40px;
          margin-bottom: 15px;
          justify-content: start;
          padding: 0 20px;
          .userInfoFormStyle-price-item {
            width: 50%;
          }
        }
        .el-select .el-input {
          width: 180px;
        }
        .el-input {
          width: 250px;
        }
        .dialog-footer {
          text-align: center;
        }
        .roleStyle {
          .el-form-item__content {
            display: flex;
            align-items: center;
            .el-form-item__content {
              margin-left: 0 !important;
            }
            img {
              width: 20px;
              height: 20px;
              margin-left: 10px;
              cursor: pointer;
            }
            .el-button {
              border: none;
              padding-left: 5px;
            }
            .el-button:focus,
            .el-button:hover {
              background-color: #fff;
            }
          }
        }
      }
    }
    
    .teach-extend-box {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .teach-extend-box-tc {
        color: #d9001b;
      }
    }
    /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    /deep/ input[type="number"] {
      -moz-appearance: textfield !important;
    }
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      background-color: #409eff;
      color: #fff;
      border: 1px solid #409eff;
    }
    /deep/.el-tree-node__content {
      display: flex;
      align-items: center;
      height: 40px;
      cursor: pointer;
      padding-right: 15px;
    }
    
.folderListBox {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .folderItem {
    width: 300px;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    padding: 10px 20px;
    border: 1px solid #ddd;
    border-radius: 20px;
    .imgBox{
      display: block;
      width: 300px;
      height: 190px;
      position: relative;
      .zzc{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(../../assets/img/zhizhao.png) center center no-repeat;
        background-size: 50px 50px;
      }
      .img {
        width: 300px;
        height: 190px;
      }

    }
    .cont {
      word-wrap: break-word;
      text-align: left;
      line-height: 30px;
      margin-bottom: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      i{
        margin-right: 10px;
      }
    }
  }
}
    </style>
    